import React from 'react';

import logoBottom from '../../images/ulysses.png';

const ulylogoBottom = (props) => (
    <span style={{ marginRight: '65px' }} ><img className="logo-lg" src={logoBottom} /></span>

);
export default ulylogoBottom;




// WEBPACK FOOTER //
// ./src/components/Logo/logoUlysses.js